module.exports = __webpack_public_path__ + "static/img/testimony (61).9534866b.jpg";